import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  actionFetchPrimaryUserUpdateList,
  actionChangePagePrimaryUserUpdateList,
} from "../../../actions/PrimaryUserUpdateList.action";
import historyUtils from "../../../libs/history.utils";
import LogUtils from "../../../libs/LogUtils";
import RouteName from "../../../routes/Route.name";
import { serviceGetList } from "../../../services/index.services";

const usePrimaryUserUpdateListHook = ({ }) => {
  const [isCalling, setIsCalling] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [listData, setListData] = useState({
    LOCATIONS: [],
  });

  const dispatch = useDispatch();
  const isMountRef = useRef(false);

  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
  } = useSelector((state) => state.primary_user_update);

  useEffect(() => {
    dispatch(
      actionFetchPrimaryUserUpdateList(1, sortingData, {
        query: query,
        query_data: isMountRef.current ? queryData : null,
      })
    );
    isMountRef.current = true;
  }, [dispatch, query, queryData, sortingData]);

  useEffect(() => {
    serviceGetList(["LOCATIONS"]).then((res) => {
      if (!res.error) {
        setListData(res.data);
      }
    });
  }, []);
  const handlePageChange = useCallback((type) => {
    dispatch(actionChangePagePrimaryUserUpdateList(type));
  }, [dispatch]);


  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchPrimaryUserUpdateList(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      queryFilter("FILTER_DATA", value);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      dispatch(
        actionFetchPrimaryUserUpdateList(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
          }
        )
      );
    },
    [query, queryData]
  );

  const handleRowSize = (page) => {
    console.log(page);
  };

  const handleEdit = useCallback(
    (data) => {
      setEditData(data);
    },
    [setEditData]
  );

  const handleCreateFed = useCallback(
    (data) => {
      LogUtils.log("data", data);
      historyUtils.push(`${RouteName.VENDOR_CREATE}`);
    },
    []);


  const handleViewUpdate = useCallback((data) => {
    LogUtils.log("data", data);
    historyUtils.push(`${RouteName.PRIMARY_USER_UPDATE}${data?.id}`);
  }, []);

  const formatedUrl = (webUrl) => {
    const chunkSize = 40;

    const urlChunks = [];
    for (let i = 0; i < webUrl.length; i += chunkSize) {
      urlChunks.push(webUrl.substring(i, i + chunkSize));
    }

    return urlChunks.join(".");
  };

  const handleToggle = useCallback(
    (obj) => {
      setIsOpen((e) => !e);
    },
    [isOpen, setIsOpen]
  );


  const configFilter = useMemo(() => {
    return [  ];
  }, []);


  const handleOpenCategory = useCallback((data) => {
    historyUtils.push(`${RouteName.CATEGORY}`);
  }, []);


  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleRowSize,
    handleSortOrderChange,
    handleEdit,
    handleCreateFed,
    isCalling,
    editData,
    configFilter,
    handleViewUpdate,
    formatedUrl,
    handleToggle,
    isOpen,
    handleOpenCategory,
  };
};

export default usePrimaryUserUpdateListHook;
